import { Duration } from 'helper/time'

export function nameFormat(name: {
  lastName: string
  firstName: string
}): string {
  return `${name.lastName} ${name.firstName}`
}

export const monthFormatStr = 'YYYY-MM'

export function durationFormat(duration: Duration): string {
  const hourStr = duration.hour.toString().padStart(2, '0')
  const minuteStr = duration.minute.toString().padStart(2, '0')
  return `${hourStr}:${minuteStr}`
}

export function durationParse(duration: string): Duration | null {
  const durationRegex = /^([0-9]{1,2}):([0-9]{2})$/ // HH:mm形式チェック用の正規表現
  const match = duration.match(durationRegex)
  if (match) {
    const hour = parseInt(match[1], 10)
    const minute = parseInt(match[2], 10)

    return { hour, minute }
  }
  return null
}
